import React from "react";
import { observer } from "mobx-react-lite";
import { TailwindModal } from "../../../components";
import { useStore } from "../../../helpers";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { Button } from "@mui/material";
import { useDeleteWebLink } from "../hooks/useWebLinkQueries";

export const DeleteWebLinkModal = observer(() => {
  const { activeSurveyStore } = useStore();
  const activeWebLink = activeSurveyStore.activeWebLink;
  const deleteWebLinkMutation = useDeleteWebLink();

  const handleDelete = () => {
    if (!activeWebLink) return;
    deleteWebLinkMutation.mutate(activeWebLink.id);
  };

  const handleClose = () => {
    activeSurveyStore.setDeleteWebLinkModalOpen(false);
    activeSurveyStore.setActiveWebLink(null);
  };

  if (!activeWebLink) return null;

  return (
    <TailwindModal
      isOpen={activeSurveyStore.deleteWebLinkModalOpen}
      onClose={handleClose}
    >
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-lg w-full mx-auto">
        <div className="flex items-center justify-center mb-4">
          <div className="flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
            <ExclamationTriangleIcon
              className="h-6 w-6 text-red-600"
              aria-hidden="true"
            />
          </div>
        </div>
        <div className="text-center">
          <h3 className="text-lg leading-6 font-medium text-gray-900 mb-2">
              Delete Survey Interview Link
            </h3>
            <div className="mt-2">
              <p className="text-sm text-gray-500">
                Are you sure you want to delete this interview link? This action cannot be undone.
              </p>
              {activeWebLink.title && (
                <p className="text-sm font-medium text-gray-700 mt-2">
                  Title: {activeWebLink.title}
                </p>
              )}
              <p className="text-sm text-gray-600 mt-1">
                GUID: {activeWebLink.guid}
              </p>
            </div>
          </div>
        <div className="mt-5 flex justify-center gap-3">
          <Button
            variant="contained"
            color="error"
            onClick={handleDelete}
            sx={{ minWidth: 100 }}
          >
            Delete
          </Button>
          <Button
            variant="outlined"
            onClick={handleClose}
            sx={{ minWidth: 100 }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </TailwindModal>
  );
});

